import React from 'react';
import { TextBody } from '@ally/metronome-ui';
import { useFeatureFlags } from '../FeatureFlagContext';
import MenuLink from './MenuLink';
import { AccordionMenuItem, StyledMenuItem, StyledSubMenuList, } from './StyledMenuComponents';
import { StyledAccordionWrapper } from './AccordionSubMenu';
import { getInvestDocumentsTitle, getInvestWealthAllytmln } from './utils';
import { useAccordionClose } from './useAccordionClose';
const DocumentsContent = ({ accordionId, showBank, showMortgage, showAuto, showCreditCard, showInvest, showWealthManagement, isInvest, isWealthClient, title, ariaLabel, linkInfo, closeMenu, routeInEmber, activeAccordion, updateAccordionState, firstAutoAccountId, routeLinks, }) => {
    const { isWealthManagement, isPersonalAdviceEnabled } = useFeatureFlags();
    useAccordionClose({
        accordionId,
        activeAccordion,
        updateAccordionState,
    });
    return (React.createElement(StyledSubMenuList, { "aria-label": ariaLabel },
        showBank && (React.createElement(React.Fragment, null,
            React.createElement(AccordionMenuItem, null,
                React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                    React.createElement(MenuLink, { to: "/bank/statements-and-forms", text: "Bank Statements", routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu }))),
            React.createElement(AccordionMenuItem, null,
                React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                    React.createElement(MenuLink, { to: "/bank/statements-and-forms/tax", text: "Bank Tax Forms", routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu }))))),
        (showInvest || showWealthManagement) && (React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                React.createElement(MenuLink, { to: linkInfo.investUrl, text: getInvestDocumentsTitle(showInvest, showWealthManagement, isPersonalAdviceEnabled), routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu, withAllyTM: getInvestWealthAllytmln(isWealthManagement, isInvest, isWealthClient, isPersonalAdviceEnabled, title) })))),
        showCreditCard && (React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                React.createElement(MenuLink, { to: routeLinks.documents.creditCardUrl, text: "Credit Card Documents", routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu })))),
        showAuto && (React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                React.createElement(MenuLink, { to: `/sso/auto/document-center/${firstAutoAccountId}/all-documents`, text: "Vehicle Documents", routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu, withAllyTM: "vehicleDocuments-profileAndSettings" })))),
        showMortgage && (React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                React.createElement(MenuLink, { to: routeLinks.documents.mortgageUrl, text: "Home Loan Documents", routeInEmber: routeInEmber, closeMenu: closeMenu }))))));
};
export default function DocumentsMenu({ roles, outages, isWealthClient, routeInEmber, routeLinks, hasNoAccounts, closeMenu, activeAccordion, updateAccordionState, firstAutoAccountId, allRestrictedCCAccounts, }) {
    const featureFlags = useFeatureFlags();
    const { isAutoEnabled, isCreditCardEnabled, isMortgageEnabled, isWealthManagement, } = featureFlags;
    const showBank = roles.bank && !outages.bank && !hasNoAccounts;
    const showInvest = roles.invest && !outages.invest;
    const showWealthManagement = isWealthManagement && isWealthClient && !outages.wealth;
    const showCreditCard = isCreditCardEnabled &&
        roles.creditCard &&
        !outages.creditCard &&
        !allRestrictedCCAccounts;
    const showMortgage = isMortgageEnabled && roles.mortgage && !outages.mortgage;
    const showAuto = Boolean(isAutoEnabled && roles.auto && !outages.auto && firstAutoAccountId);
    const visibleLobs = [
        { name: 'bank', visible: showBank, outage: outages.bank },
        {
            name: 'invest',
            visible: showInvest || showWealthManagement,
            outage: outages.invest,
        },
        {
            name: 'mortgage',
            visible: showMortgage,
            outage: outages.mortgage,
        },
        { name: 'auto', visible: showAuto, outage: outages.auto },
        {
            name: 'creditCard',
            visible: showCreditCard,
            outage: outages.creditCard,
        },
    ].filter(obj => obj.visible);
    const areAllVisibleLobsDown = visibleLobs.every(obj => obj.outage);
    if (areAllVisibleLobsDown) {
        return React.createElement(React.Fragment, null);
    }
    const showAccordion = showBank || visibleLobs.length > 1 || (isAutoEnabled && visibleLobs.length);
    if (showAccordion) {
        return (React.createElement(StyledAccordionWrapper, { key: "documents-submenu", disableContainer: true, items: [
                {
                    heading: 'Documents',
                    panel: (React.createElement(DocumentsContent, { accordionId: "documents", showBank: showBank, showWealthManagement: showWealthManagement, showInvest: showInvest, showMortgage: showMortgage, showAuto: showAuto, showCreditCard: showCreditCard, isInvest: roles.invest, isWealthClient: roles.wealth, isWealthDown: outages.wealth, isInvestDown: outages.invest, instanceKey: "documents-submenu", title: "Documents", ariaLabel: "Documents", linkInfo: routeLinks.statements, closeMenu: closeMenu, routeInEmber: routeInEmber, activeAccordion: activeAccordion, updateAccordionState: updateAccordionState, firstAutoAccountId: firstAutoAccountId, routeLinks: routeLinks })),
                },
            ] }));
    }
    if (showInvest || showWealthManagement) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.documents.investUrl, text: routeLinks.documents.content, closeMenu: closeMenu })));
    }
    if (showMortgage) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.documents.mortgageUrl, text: routeLinks.documents.content, routeInEmber: routeInEmber, closeMenu: closeMenu, withAllyTM: "Documents - Home Loans" })));
    }
    if (showCreditCard) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.documents.creditCardUrl, text: routeLinks.documents.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=DocumentsMenu.js.map